import { DocumentNode } from 'graphql';
import React from 'react';
import {
  LookupModel,
  UserLookupsDocument,
  UserLookupsQuery,
  UserLookupsQueryVariables,
} from 'types/graphql';

interface IProps {
  includeDeleted?: boolean;
  includeInactive?: boolean;
  firstPeriodId?: number | null;
  lastPeriodId?: number | null;
  includeId?: number;
  children: (value: {
    queryDocument: DocumentNode;
    queryVariables: UserLookupsQueryVariables;
    extractLookups: (query: UserLookupsQuery) => LookupModel[];
  }) => React.ReactNode;
}

export const UserLookupWrapper = (props: IProps): JSX.Element => {
  return (
    <>
      {props.children({
        queryDocument: UserLookupsDocument,
        queryVariables: {
          includeId: props.includeId,
          includeDeleted: props.includeDeleted,
          firstPeriodId: props.firstPeriodId,
          lastPeriodId: props.lastPeriodId,
          excludeIfHasInactiveBeginningYYYYMM: !props.includeInactive,
        },
        extractLookups: (query) => query.userLookups,
      })}
    </>
  );
};
